import WalletTypeIcon from "./WalletTypeIcon";

export default WalletTypeIcon;